import React, { useState, useEffect } from 'react';
import './CSS/style.css';
import './CSS/school wave.css';
import './CSS/base theme.css';
import './CSS/animate.css';
import './CSS/fonts.css';
import './CSS/jquery.css';
import './CSS/upload theme.css';
import './CSS/sprye.css';
import './CSS/fancybax.css';
import { grey } from '@mui/material/colors';
import { colors } from '@mui/material';
import pic from "./images/front.jpeg"
import pic2 from "./images/back.jpeg"
// import pic from "picc.png"

const carouselImages = [
  { src: pic, alt: "Product Mockup 1" },
  { src: pic2, alt: "Product Mockup 2" }
];

const ProductPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div className="fl-content-full container">
        <div className="row">
          <div className="fl-content col-md-12">
            <article
              className="fl-post post-7769 page type-page status-publish hentry"
              id="fl-post-7769"
              itemScope
              itemType="https://schema.org/CreativeWork"
            >
              <div className="fl-post-content clearfix" itemProp="text">
                <div
                  className="fl-builder-content fl-builder-content-7769 fl-builder-content-primary fl-builder-global-templates-locked"
                  data-post-id="7769"
                >
                  <div
                    id="hero-products"
                    className="fl-row fl-row-fixed-width fl-row-bg-none fl-node-56a2b1bda41de fl-row-default-height fl-row-align-center"
                    data-node="56a2b1bda41de"
                  >
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5c9b94b5d85ba" data-node="5c9b94b5d85ba">
                          <div className="fl-col fl-node-5c9b94b5d87bb fl-col-bg-color" data-node="5c9b94b5d87bb">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5cfaceeb1caeb" data-node="5cfaceeb1caeb">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemscope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      {/* Uncomment if the image is needed */}
                                      {/* <img loading="lazy" decoding="async" className="fl-photo-img wp-image-5585 size-full" src="images/schoolwavelogo.png" alt="SchoolCity" itemProp="image" height="39" width="32" title="SchoolCity" /> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="fl-module fl-module-heading fl-node-5cfacecf9a8f3" data-node="5cfacecf9a8f3">
                                <div className="fl-module-content fl-node-content">
                                  <h1 className="fl-heading">
                                    <span className="heading-1">
                                      Simplified Interface which Transits from Pen to Pixel
                                    </span>
                                  </h1>
                                </div>
                              </div>
                              <div className="fl-module fl-module-heading fl-node-5c9b94b5d849d" data-node="5c9b94b5d849d">
                                <div className="fl-module-content fl-node-content">
                                  <h3 className="fl-heading">
                                    <span className="heading-1">
                                      SchoolWave simplifies the customary practice of routine
                                      into customized platform with simplified and ease to access User Interface,
                                      which includes creating, saving, and extracting the daily routine data in a single click
                                    </span>
                                  </h3>
                                </div>
                              </div>
                              {/* Uncomment button section if needed */}
                              {/* 
                              <div className="fl-module fl-module-button fl-node-mr54e9fg7z3t btn-shadow" data-node="mr54e9fg7z3t">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-button-wrap fl-button-width-auto fl-button-center">
                                    <a href="#" target="_self" className="fl-button">
                                      <span className="fl-button-text">Schedule 1:1</span>
                                    </a>
                                  </div>
                                </div>
                              </div> 
                              */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product Overview Section */}
                  <div className="fl-col-group fl-node-5cfad164c5a05" id="product" data-node="5cfad164c5a05" style={{ Top: '-50px' }}>
                    <div className="fl-col fl-node-5cfad164c5c04 fl-col-bg-color" data-node="5cfad164c5c04">
                      <div className="fl-col-content fl-node-content">
                        <div className="fl-module fl-module-button fl-node-5cfad164c58e5" data-node="5cfad164c58e5">
                          <div className="fl-module-content fl-node-content">
                            <div className="fl-button-wrap fl-button-width-auto fl-button-center">
                              <a
                                href="./pdff.pdf"
                                target="_blank"
                                className="fl-button"
                                rel="noopener"
                              >
                                <span className="fl-button-text">Download Product Overview</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product Image Section */}
                  {/* <div className="fl-module fl-module-photo fl-node-5cfad0988ce54" data-node="5cfad0988ce54" style={{width:'auto',paddingTop:'5%', alignItems: 'center', justifyContent: 'center'}}>
                    <div className="fl-module-content fl-node-content">
                      <div className="fl-photo fl-photo-align-center" itemscope itemType="https://schema.org/ImageObject">
                        <div className="fl-photo-content fl-photo-img-png">
                          <div className="img">
                          <img
                            fetchpriority="high"
                            decoding="async"
                            class="fl-photo-img wp-image-13615 size-full"
                            src="picc.png"
                            alt="SC_Laptop_Tablet_Mock_100dpi-sm"
                            itemprop="image"
                            height="595"
                            width="auto"
                            title="SC_Laptop_Tablet_Mock_100dpi-sm"
                            srcSet="/picc.png 10000w, /picc.png 600w, /picc.png 768w"
                            sizes="(max-width: 1000px) 100vw, 1000px"
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* Product Image Section */}
                  {/* <div className="fl-module fl-module-photo fl-node-5cfad0988ce54" data-node="5cfad0988ce54" style={{width:'auto', paddingBottom:'5%', alignItems:'center', justifyContent:'center'}}>
                    <div className="fl-module-content fl-node-content">
                      <div className="fl-photo fl-photo-align-center" itemscope itemType="https://schema.org/ImageObject">
                        <div className="fl-photo-content fl-photo-img-png">
                          <div className="img">
                          <img
                            fetchpriority="high"
                            decoding="async"
                            class="fl-photo-img wp-image-13615 size-full"
                            src="pic.jpeg"
                            alt="SC_Laptop_Tablet_Mock_100dpi-sm"
                            itemprop="image"
                            title="SC_Laptop_Tablet_Mock_100dpi-sm"
                            srcSet="/pic.jpeg 10000w, /pic.jpeg 600w, /pic.jpeg 768w"
                            sizes="(max-width: 1000px) 100vw, 1000px"
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <h1 className="fl-heading" style={{ marginTop: '100px', textAlign: 'center' }}>
                    <span className="heading-1">
                      <span style={{ color: '#010041' }}>India's most Trusted</span> <span style={{ color: '#e8511f' }}>School Management Software</span>
                    </span>
                  </h1>

                  <div className="product-section">
                    <div className="image-wrapper">
                      <img
                        src="/picc.png"
                        alt="Product Mockup 1"
                        className="responsive-img"
                      />
                    </div>


                    {/* <div className="image-wrapper">
                      <img
                        src="/pic.jpeg"
                        alt="Product Mockup 2"
                        className="responsive-img"
                      />
                     </div> */}
                  </div>



                  {/* Right Background Image Section */}
                  <div className="fl-row fl-row-full-width fl-row-bg-photo fl-node-5cfad0df039c3 fl-row-default-height fl-row-align-center trapezoid-right-background product-image-right" data-node="5cfad0df039c3">
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator" />
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5cfad0df0e6a1" data-node="5cfad0df0e6a1">
                          <div className="fl-col fl-node-5cfad0df0e9cc fl-col-bg-color" data-node="5cfad0df0e9cc">

                          </div>
                        </div>

                        <div className="fl-col-group fl-node-5cfad1294ceac fl-col-group-equal-height fl-col-group-align-top" data-node="5cfad1294ceac">
                          <div className="fl-col fl-node-5cfad1294d10c fl-col-bg-color" data-node="5cfad1294d10c">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-heading fl-node-611fe69522f3a" data-node="611fe69522f3a">
                                <div className="fl-module-content fl-node-content">
                                  <h3 className="fl-heading">
                                    {/* <span class="fl-heading-text">Standards-based assessments and information-rich reporting to deeply understand student learning and inform instructional next steps for each unique student.</span> */}
                                  </h3>
                                </div>
                              </div>
                              <div className="fl-module fl-module-rich-text fl-node-5cfad3eb526ea" data-node="5cfad3eb526ea">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-col-content fl-node-content">
                                    <div className="fl-module fl-module-photo fl-node-5d08faac066ff" data-node="5d08faac066ff">
                                      <div className="fl-module-content fl-node-content">
                                        <div className="fl-photo fl-photo-align-left" itemScope itemType="https://schema.org/ImageObject">
                                          <div className="fl-photo-content fl-photo-img-svg">
                                            <img
                                              loading="lazy"
                                              decoding="async"
                                              className="fl-photo-img wp-image-5171 size-full"
                                              src="/triangle.svg"
                                              alt="triangle"
                                              itemProp="image"
                                              height="46"
                                              width="83"
                                              title="triangle"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="fl-module fl-module-heading fl-node-5cfad0df01ebb" data-node="5cfad0df01ebb">
                                      <div className="fl-module-content fl-node-content">
                                        <h2 className="fl-heading">
                                          <span className="fl-heading-text">BENEFITS</span>
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="fl-rich-text">
                                    <ul>
                                      <li>
                                        <strong>Quickly draft the architecture using BUILD SCHOOL</strong> to set the layouts of school body like standards, subjects, timings etc.
                                      </li>
                                      <li>
                                        <strong>Modules based architecture which ease in process</strong> like attendance, fees, reports generation, students and staff modules.
                                      </li>
                                      <li>
                                        <strong>Promote fingertip access for</strong> all users to track and process the works in the respective modules only.
                                      </li>
                                      <li>
                                        <strong>Generate reports instantly</strong> in no time and get the report data in excel sheet and pdf format in a split-second process.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="fl-col fl-node-5cfad14141880 fl-col-bg-color fl-col-small" data-node="5cfad14141880" style={{ marginTop: '50px', paddingLeft: 20 }}>
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5cfad14141505 img-round img-shadow" data-node="5cfad14141505">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-jpg ">
                                      <img
                                        loading="lazy"
                                        decoding="async"
                                        className="benifits fl-photo-img wp-image-7773 size-full"
                                        src="/BuildSchool.jpeg"
                                        alt="BuildSchool"
                                        itemProp="image"
                                        height="513"
                                        width="600"
                                        title="BuildSchool"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </div>

                        </div>
                        <div className="fl-module fl-module-heading fl-node-5cfacecf9a8f3" data-node="5cfacecf9a8f3">
                          <div className="fl-module-content fl-node-content">
                            <h1 className="fl-heading">
                              {/* <img class="fl-heading-text" src="images/schoolwavelogo.png" /> */}
                              <span className="heading">How Does SchoolWave Help You?</span>
                            </h1>
                          </div>
                        </div>

                      </div>
                    </div>


                  </div>

                  <div className="fl-row fl-row-full-width fl-row-bg-none fl-node-5cfad3bef1d81 fl-row-default-height fl-row-align-center product-image-left" data-node="5cfad3bef1d81">
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5cfad3bf0da40 fl-col-group-equal-height fl-col-group-align-center" data-node="5cfad3bf0da40">
                          <div className="fl-col fl-node-5cfad3bf0dc8b fl-col-bg-color fl-col-small" data-node="5cfad3bf0dc8b">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5cfad3bef0868 img-round img-shadow img-border" data-node="5cfad3bef0868">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-jpg">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-7778 size-full" src="/LaunchPad.jpeg" alt="WholeChildSupport" itemProp="image" height="339" width="601" title="WholeChildSupport" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="fl-col fl-node-5cfad3da46bd6 fl-col-bg-color" data-node="5cfad3da46bd6">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5d08fab28e344" data-node="5d08fab28e344">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-left" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-5171 size-full" src="/triangle.svg" alt="triangle" itemProp="image" height="46" width="83" title="triangle" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="fl-module fl-module-heading fl-node-5cfad3d43856b" data-node="5cfad3d43856b">
                                <div className="fl-module-content fl-node-content">
                                  <h2 className="fl-heading">
                                    <span className="fl-heading-text">Ease in Use</span>
                                  </h2>
                                </div>
                              </div>
                              <div className="fl-module fl-module-rich-text fl-node-5cfad1294cd41" data-node="5cfad1294cd41">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <ul>
                                      <li><strong>Biforge into two major parts:</strong> BuildSchool and Launchpad, which is for setting the blueprint structure and for the customary action using the created structure.</li>
                                      <li><strong>Provide Simplified yet delightful interface</strong> which simplifies the chronic activities of educational institutions.</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="fl-row fl-row-full-width fl-row-bg-photo fl-node-5f441f92bbcf7 fl-row-default-height fl-row-align-center product-image-right" data-node="5f441f92bbcf7">
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5f441f92bbeae fl-col-group-equal-height fl-col-group-align-center" data-node="5f441f92bbeae">
                          <div className="fl-col fl-node-5f441f92bbeaf fl-col-bg-color fl-col-small" data-node="5f441f92bbeaf">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5f441f92bbeb0" data-node="5f441f92bbeb0">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-left" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-5171 size-full" src="/triangle.svg" alt="triangle" itemProp="image" height="46" width="83" title="triangle" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="fl-module fl-module-heading fl-node-5f441f92bbeb1" data-node="5f441f92bbeb1">
                                <div className="fl-module-content fl-node-content">
                                  <h2 className="fl-heading">
                                    <span className="fl-heading-text">Accommodations</span>
                                  </h2>
                                </div>
                              </div>
                              <div className="fl-module fl-module-rich-text fl-node-5f441f92bbeb2" data-node="5f441f92bbeb2">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <p>Shift of work from onPaper to online.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="fl-module fl-module-rich-text fl-node-5f441f92bbeb3 no-paragraph-space teal-text uppercase" data-node="5f441f92bbeb3">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <p><strong>Features</strong></p>
                                  </div>
                                </div>
                              </div>
                              <div className="fl-module fl-module-rich-text fl-node-5f441f92bbeb4 no-paragraph-space" data-node="5f441f92bbeb4">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <ul>
                                      <li>Tracking Pupil’s Status</li>
                                      <li>Daily Attendance Status</li>
                                      <li>Designation based Access</li>
                                      <li>Up-to-Date Reports</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="fl-col fl-node-5f441f92bbeb5 fl-col-bg-color fl-col-small" data-node="5f441f92bbeb5">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5f441f92bbeb6 img-round img-shadow img-border" data-node="5f441f92bbeb6">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-jpg">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-7772 size-full" src="/Attendence.jpeg" alt="Accommodations" itemProp="image" height="331" width="600" title="Accommodations" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="fl-row fl-row-full-width fl-row-bg-none fl-node-5cfad5916ed7f fl-row-default-height fl-row-align-center product-image-left" data-node="5cfad5916ed7f">
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5cfad5916f192 fl-col-group-equal-height fl-col-group-align-center" data-node="5cfad5916f192">
                          <div className="fl-col fl-node-5cfad5916f196 fl-col-bg-color fl-col-small" data-node="5cfad5916f196">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5cfad5916f198 img-round img-shadow" data-node="5cfad5916f198">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-png">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-7774 size-full" src="/Fees.jpeg" alt="HQ-Assessment-Content" itemProp="image" height="387" width="550" title="HQ-Assessment-Content" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="fl-col fl-node-5cfad5916f199 fl-col-bg-color fl-col-small" data-node="5cfad5916f199">
                            <div className="fl-col-content fl-node-content">
                              <div className="fl-module fl-module-photo fl-node-5d08fab97362c" data-node="5d08fab97362c">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-left" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      <img loading="lazy" decoding="async" className="fl-photo-img wp-image-5171 size-full" src="/triangle.svg" alt="triangle" itemProp="image" height="46" width="83" title="triangle" />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="fl-module fl-module-heading fl-node-5cfad5916f19a" data-node="5cfad5916f19a">
                                <div className="fl-module-content fl-node-content">
                                  <h2 className="fl-heading">
                                    <span className="fl-heading-text">High-Quality Data Control</span>
                                  </h2>
                                </div>
                              </div>

                              <div className="fl-module fl-module-rich-text fl-node-5cfad5916f19b" data-node="5cfad5916f19b">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <ul>
                                      <li><strong>Well Architectured DataFlow</strong> aligned uniformly in database as secured document folders.</li>
                                      <li><strong>Maintains the record of students</strong> with any academic years and so for the staff which includes the attendance, active status, and other aspects.</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="fl-row fl-row-full-width fl-row-bg-photo fl-node-5cfad4f111823 fl-row-default-height fl-row-align-center product-image-right" data-node="5cfad4f111823">
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-5cfad4f111be4 fl-col-group-equal-height fl-col-group-align-center" data-node="5cfad4f111be4">

                          {/* First Column */}
                          <div className="fl-col fl-node-5cfad4f111be9 fl-col-bg-color fl-col-small" data-node="5cfad4f111be9">
                            <div className="fl-col-content fl-node-content">

                              {/* Triangle Icon */}
                              <div className="fl-module fl-module-photo fl-node-5d08fa8931a3a" data-node="5d08fa8931a3a">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-left" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      <img
                                        loading="lazy"
                                        decoding="async"
                                        className="fl-photo-img wp-image-5171 size-full"
                                        src="/triangle.svg"
                                        alt="triangle"
                                        itemProp="image"
                                        height="46"
                                        width="83"
                                        title="triangle"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Heading */}
                              <div className="fl-module fl-module-heading fl-node-5cfad4f111beb" data-node="5cfad4f111beb">
                                <div className="fl-module-content fl-node-content">
                                  <h2 className="fl-heading">
                                    <span className="fl-heading-text">Real-Time Reporting</span>
                                  </h2>
                                </div>
                              </div>

                              {/* Description */}
                              <div className="fl-module fl-module-rich-text fl-node-5cfad4f111bec" data-node="5cfad4f111bec">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <ul>
                                      <li>Actionable reporting dashboard</li>
                                      <li>Item, Objective and Standards analysis reports</li>
                                      <li>Aggregated data based on user type</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Second Column */}
                          <div className="fl-col fl-node-5cfad4f751f8e fl-col-bg-color fl-col-small" data-node="5cfad4f751f8e">
                            <div className="fl-col-content fl-node-content">

                              {/* Image */}
                              <div className="fl-module fl-module-photo fl-node-5cfad4f111be8 img-round img-shadow img-border" data-node="5cfad4f111be8">
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-photo fl-photo-align-center" itemScope itemType="https://schema.org/ImageObject">
                                    <div className="fl-photo-content fl-photo-img-jpg">
                                      <img
                                        loading="lazy"
                                        decoding="async"
                                        className="fl-photo-img wp-image-7775 size-full"
                                        src="/TimeTable.jpeg"
                                        alt="Real-Time-Reporting"
                                        itemProp="image"
                                        height="354"
                                        width="600"
                                        title="Real-Time-Reporting"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div
                    id="cta-secondary-rectangle"
                    className="fl-row fl-row-full-width fl-row-bg-photo fl-node-615f1ae67aa14 fl-row-default-height fl-row-align-center"
                    data-node="615f1ae67aa14"
                  >
                    <div className="fl-row-content-wrap">
                      <div className="uabb-row-separator uabb-top-row-separator"></div>
                      <div className="fl-row-content fl-row-fixed-width fl-node-content">
                        <div className="fl-col-group fl-node-615f1ae67ab02" data-node="615f1ae67ab02">

                          {/* First Column */}
                          <div className="fl-col fl-node-615f1ae67ab03 fl-col-bg-color" data-node="615f1ae67ab03">
                            <div className="fl-col-content fl-node-content">

                              {/* Lightbulb Image */}
                              <div
                                className="fl-module fl-module-photo fl-node-615f1ae67ab04"
                                data-node="615f1ae67ab04"
                              >
                                <div className="fl-module-content fl-node-content">
                                  <div
                                    className="fl-photo fl-photo-align-center"
                                    itemscope
                                    itemType="https://schema.org/ImageObject"
                                  >
                                    <div className="fl-photo-content fl-photo-img-svg">
                                      <img
                                        loading="lazy"
                                        decoding="async"
                                        className="fl-photo-img wp-image-5103 size-full"
                                        src="https://www.illuminateed.com/wp-content/uploads/2019/05/Lightbulb-1.svg"
                                        alt="Lightbulb"
                                        itemProp="image"
                                        height="121"
                                        width="118"
                                        title="Lightbulb"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>




                              {/* Heading */}
                              <div
                                className="fl-module fl-module-heading fl-node-615f1ae67ab05"
                                data-node="615f1ae67ab05"
                              >
                                <div className="fl-module-content fl-node-content">
                                  <h2 className="fl-heading">
                                    <span className="fl-heading-text">Want to See How it Works?</span>
                                  </h2>
                                </div>
                              </div>

                              {/* Text */}
                              <div
                                className="fl-module fl-module-rich-text fl-node-615f1ae67ab06 blue-text"
                                data-node="615f1ae67ab06"
                              >
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-rich-text">
                                    <p style={{ textAlign: 'center' }}>
                                      We'd love to learn more about your unique needs and discuss how we can support you.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* Button */}
                              <div
                                className="fl-module fl-module-button fl-node-615f1ae67ab07 uppercase"
                                data-node="615f1ae67ab07"
                              >
                                <div className="fl-module-content fl-node-content">
                                  <div className="fl-button-wrap fl-button-width-auto fl-button-center">
                                    <a href="#" target="_self" className="fl-button">
                                      <span className="fl-button-text">I'd like a demo!</span>
                                    </a>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="product-section-bottom">
                    <img
                      src="/01.jpeg"
                      alt="Static 03"
                      style={{ width: '100%', maxWidth: '1000px', height: 'auto', display: 'block', marginBottom: '20px' }}
                    />
                    {carouselImages.map((image, index) => (
                      <div
                        key={index}
                        className="image-wrapper-bottom"
                        style={{ display: index === currentImageIndex ? 'block' : 'none' }}
                      >
                        <img src={image.src} alt={image.alt} className="responsive-img-bottom" />
                      </div>
                    ))}
                  </div>



                </div>
              </div>
            </article>
          </div>

        </div>
      </div>
    </>

  );
};

export default ProductPage;
